import React from 'react';
import './Loader.css';

const Loader = ({ message = 'Loading...' }) => {
  return (
    <div className="uni-loader">
      <div className="uni-loader-spinner"></div>
      <p className="uni-loader-message">{message}</p>
    </div>
  );
};

export default Loader;
